import React from "react";
import { Users, Crosshair, Zap } from "lucide-react";
import { manifesto, howWeThink } from "../mock";

const ICONS = { Users, Crosshair, Zap };

export default function Manifesto() {
  return (
    <>
      <section className="relative overflow-hidden bg-transparent py-24 md:py-32">
        <div className="mx-auto grid max-w-[1500px] items-center gap-14 px-5 md:grid-cols-[1.2fr_0.8fr] md:px-10">
          <div className="reveal">
            {manifesto.lines.map((l, i) => (
              <h2 key={i} className="font-display text-6xl text-[var(--crtr-yellow)] sm:text-7xl md:text-8xl">{l}</h2>
            ))}
            <p className="mt-8 max-w-md text-base leading-relaxed text-white/60">{manifesto.note}</p>
          </div>
          <div className="reveal space-y-8 md:border-l md:border-white/15 md:pl-12">
            {manifesto.principles.map((p, i) => {
              const Icon = ICONS[p.icon];
              return (
                <div key={i} className="flex items-center gap-5">
                  <span className="flex h-12 w-12 flex-none items-center justify-center rounded-full border border-[var(--crtr-yellow)]">
                    <Icon className="h-5 w-5 text-[var(--crtr-yellow)]" strokeWidth={1.6} />
                  </span>
                  <span className="font-heavy text-lg uppercase text-white">{p.text}</span>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden border-t border-white/10 bg-transparent py-24 md:py-32">
        <div className="mx-auto max-w-[1500px] px-5 md:px-10">
          <span className="reveal mono-label block text-xs text-[var(--crtr-yellow)]">{howWeThink.kicker}</span>
          <div className="reveal mt-5 grid gap-10 md:grid-cols-[1.1fr_0.9fr] md:items-end">
            <h2 className="font-display text-5xl text-white sm:text-6xl md:text-7xl">
              {howWeThink.title.map((t, i) => (
                <span key={i} className="block">{t}</span>
              ))}
              <span className="text-[var(--crtr-yellow)]">))</span>
            </h2>
            <p className="text-lg leading-relaxed text-white/65">{howWeThink.body}</p>
          </div>
        </div>
      </section>
    </>
  );
}
